import React from "react";
import { Redirect, Route } from "react-router-dom";
import PublicLayout from "../layout/PublicLayout";
import { isLoggedIn } from "../utils/helper";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn() && restricted ? (
          <Redirect to="/app" />
        ) : (
          <PublicLayout>
            <Component {...props} />
          </PublicLayout>
        )
      }
    />
  );
};

export default PublicRoute;
